import { Outlet } from 'react-router-dom'
import { useResponsive } from '@/contexts/ResponsiveContext'

const AuthLayout = () => {
  const { isMobile } = useResponsive()

  return (
    <div className={`min-h-screen bg-gray-50 flex flex-col justify-center ${isMobile ? 'py-6 px-4' : 'py-12 sm:px-6 lg:px-8'}`}>
      <div className={`mx-auto w-full ${isMobile ? 'max-w-sm' : 'sm:max-w-md'}`}>
        <div className="text-center">
          <h1 className={`font-bold text-gray-900 ${isMobile ? 'text-2xl' : 'text-3xl'}`}>
            Admin Dashboard
          </h1>
          <p className={`mt-2 text-gray-600 ${isMobile ? 'text-sm' : 'text-sm'}`}>
            Dual Dashboard System Management
          </p>
        </div>
      </div>

      <div className={`mx-auto w-full ${isMobile ? 'max-w-sm mt-6' : 'sm:max-w-md mt-8'}`}>
        <div className={`bg-white shadow ${isMobile ? 'py-6 px-4 rounded-lg' : 'py-8 px-4 sm:rounded-lg sm:px-10'}`}>
          <Outlet />
        </div>
      </div>

      <div className={`text-center ${isMobile ? 'mt-6' : 'mt-8'}`}>
        <p className={`text-gray-500 ${isMobile ? 'text-xs' : 'text-xs'}`}>
          © 2024 Dual Dashboard System. All rights reserved.
        </p>
      </div>
    </div>
  )
}

export default AuthLayout